import React from "react";
//import Jdenticon from "react-jdenticon";
import moment from "moment";
import numeral from "numeral";
// import { clientModelInput } from "../AdminFinanceScreen/eqCalculations";
import trashIcon from "../../icons/trashIcon.svg";
// import styled from "styled-components";

// const CellIcon = styled.div`
//   display: inline-block;
//   margin-right: 10px;
//   height: 40px;
//   line-height: 10px;
//   vertical-align: top;
//   padding-top: 5px;
//   user-select: none;
// `;

const valNames = [
  {
    name: "Gross Sales",
    editable: true,
    title: "Total of all sales without any deductions.",
    slug: "grossSales",
  },
  {
    name: "COGS/COS",
    editable: true,
    title:
      "Cost of goods and/or services sold (COGS) refers to the direct costs attributable to the production of the goods and/or services sold by the company.",
    slug: "cogs",
  },
  {
    name: "Gross Margin",
    editable: false,
    title: "Gross Sales – COGS/COS",
    slug: "grossMarginValue",
  },
  {
    name: "Gross Margin %",
    editable: false,
    percent: true,
    title: "Gross Margin/Gross Sales",
    slug: "grossMarginPercent",
    type: 'percent',
  },
  {
    name: "G & A",
    editable: true,
    title:
      "General and Administrative expenses. These are the expenses for the day-to-day operations of the company (i.e., rent, insurance, etc.).",
    slug: "ga",
  },
  {
    name: "Other Income/Expenses",
    editable: true,
    title:
      "Other income and expenses attributable to activities outside of the business (i.e., investment income, gain or loss on sale of a property, etc.).",
    slug: "otherIncome",
  },
  {
    name: "EBITDA",
    editable: false,
    title: "Earnings before Interest, Taxes, Depreciation and Amortization.",
    slug: "ebitda",
  },
  {
    name: "ITDA",
    editable: true,
    title: "Interest, Taxes, Depreciation and Amortization.",
    slug: "itda",
  },
  {
    name: "Net Income/Loss",
    editable: false,
    title: "Bottom line after all income and expenses have been accounted for.",
    slug: "netIncome",
  },
  {
    name: "Total Debt",
    editable: true,
    title: "Debt is an amount of money borrowed by one party from another.",
    slug: "totalDebt",
  },
];

export const yearCalc = (item) => {
  const grossMarginValue = item.grossSales - item.cogs;
  const ebitda = item.grossSales - item.cogs - item.ga - item.otherIncome;
  const marketCap = ebitda * (item.priceEarnings || 1);

  return {
    ...item,
    grossMarginValue,
    grossMarginPercent: grossMarginValue / item.grossSales,
    ebitda,
    netIncome: ebitda - item.itda,
    marketCap,
    enterpriseValue: marketCap - item.totalDebt,
  };
};

export const clientModelInput = (years) => years.map((item) => yearCalc(item));

export const gridSettings = (form, setForm, setDeleteModal) => {
  function handleCellChange({ value, rowIndex, col }) {
    const newForm = [...form];
    newForm[rowIndex][col.field] = value;
    setForm(newForm);
  }

  const nameCell = ({ forecastId, name }) => (
    <>
      {/* <CellIcon>
        <Jdenticon value={forecastId} size="30" />
      </CellIcon> */}
      {name}
    </>
  );

  const updateCell = ({ lastUpdated }) =>
    moment(new Date(lastUpdated)).format("MMMM Do YYYY");

  const optionsCell = ({ name, forecastId }) => (
    <div style={{ float: "right", paddingRight: 10 }}>
      <img
        height={20}
        src={trashIcon}
        alt="delete"
        style={{ cursor: "pointer", verticalAlign: "top", marginTop: "10px" }}
        onClick={() => setDeleteModal({ name, forecastId })}
      />
    </div>
  );

  const cols = [
    {
      field: "name",
      headerName: "Scenario",
      colSize: 1.5,
      comp: nameCell,
      editable: true,
      onChange: handleCellChange,
    },
    {
      field: "updated",
      headerName: "Last Updated",
      comp: updateCell,
    },
    {
      field: "options",
      comp: optionsCell,
    },
  ];

  const formatVal = (val, { row }) => {
    const { data: { type } = {} } = row;
    const types = {
      percent: numeral(val).format("0.00%"),
      number: val || val === 0 ? val : '',
    };
    let value =''
    if (type) {
      value = types[type]
    } else {
      value = numeral(val).format("$0,0[.]00")
      if (val === -0) {
        if (value.substring(0) !== '-') {
          value = `-${value}`
        }
      }
    }
    return value;
  };

  function handleYearInput(formIndex) {
    const fn = ({ value, row, col }) => {
      const name = row.data.slug;
      const yrIndex = parseInt(col.field.slice(-1)) - 1;
      const newForm = [...form];
      newForm[formIndex].years[yrIndex][name] = 
        value === "-" ? value : numeral(value).value();
      setForm(newForm);
    };
    return fn;
  }

  const editable = ({ row }) => row.data.editable;

  const comp = ({ cellValue, title }) => (
    <div style={{ userSelect: "none" }} title={title}>
      {cellValue}
    </div>
  );

  const rows = form.map((item, rowIndex) => {
    const fields = {
      name: item.name,
      id: item.forecastId,
      updated: item.lastUpdated,
    };

    const yearData = clientModelInput(item.years);

    const years = item.years.map((yr, i) => ({
      field: `year${i + 1}`,
      headerName: `Year ${i + 1}`,
      onChange: handleYearInput(rowIndex),
      editable,
      formatVal,
    }));

    const cols = [{ field: "name", headerName: "Name", comp }, ...years];
    const rows = valNames.map((val, i) => {
      const obj = { name: val.name };
      yearData.forEach((yr, yrIndex) => {
        obj[`year${yrIndex + 1}`] = yr[val.slug];
      });
      return { fields: obj, data: val, inputType: val.inputType };
    });

    const children = {
      cols,
      rows,
    };

    return { data: item, fields, children };
  });

  return { rows, cols };
};
